import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ModalModule } from '../../../../../core/modal/modal.module';
import { SharedModule } from '../../../../../shared/shared.module';
import { BusinessProcessIds } from '../../../../../core/services/bp.service';
import { ModalService } from '../../../../../core/modal/modal.service';
import { Pages } from '../../../../pages';
import { BaseKkmFields } from '../../../../../core/modules/kkms/kkms.types';

@Component({
  selector: 'tax-rca-alarm-modal',
  templateUrl: './rca-alarm-modal.component.html',
  styleUrls: ['./rca-alarm-modal.component.sass'],
  standalone: true,
  imports: [
    ModalModule,
    SharedModule,
  ],
})
export class RcaAlarmModalComponent<T extends BaseKkmFields> {
  @Input() kkmForm?: T;
  @Input() processIds?: BusinessProcessIds;
  readonly alertMessage = 'rca.alarm.modal.content';

  constructor(
    private router: Router,
    private modalService: ModalService,
  ) {}

  navigateToEditRetailPlace(): void {
    if (!this.kkmForm || !this.processIds) return;
    this.router.navigate([`${Pages.Kkms}/retailPlace/${this.kkmForm?.retailPlaceId}/edit`], {
      queryParamsHandling: 'merge',
      state: {
        state: this.kkmForm,
        previousPageUrl: this.router.url,
      },
    }).then(() => this.modalService.close());
  }
}
